var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwesomeExchangeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28.128,
    viewBox: "0 0 28 28.128",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exchange-alt",
    d: "M0,11.813V10.688A1.536,1.536,0,0,1,1.312,9H21V5.625c0-1.5,1.416-2.253,2.241-1.193l4.375,5.625a2.044,2.044,0,0,1,0,2.386l-4.375,5.625C22.419,19.124,21,18.384,21,16.875V13.5H1.312A1.536,1.536,0,0,1,0,11.813ZM26.687,22.5H7V19.125c0-1.5-1.414-2.256-2.241-1.193L.384,23.557a2.044,2.044,0,0,0,0,2.386l4.375,5.625C5.581,32.625,7,31.882,7,30.375V27H26.687A1.536,1.536,0,0,0,28,25.313V24.188A1.536,1.536,0,0,0,26.687,22.5Z",
    transform: "translate(0 -3.936)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeExchangeAlt);
export default __webpack_public_path__ + "static/media/awesome-exchange-alt.a7a027fdfb0d25fc89468fb94614a1d4.svg";
export { ForwardRef as ReactComponent };